import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M3.333 2.667v2.666a.667.667 0 00.667.667h2.667a.667.667 0 100-1.334H5.38c.847-.847 2.02-1.333 3.287-1.333a4.667 4.667 0 110 9.334.667.667 0 000 1.333 6 6 0 100-12c-1.68 0-3.2.7-4.267 1.813V2.667a.667.667 0 00-1.333 0z"
      ></path>
    </svg>
  )
}

export default Icon